module.exports = __webpack_public_path__ + "img/header-separator.bc69fe9c.png";